import { check } from 'react-icons-kit/fa/check';
import { close } from 'react-icons-kit/fa/close';
import { minus } from 'react-icons-kit/fa/minus';

export const STATE_ICON = {
  correct: check,
  incorrect: close,
  indeterminate: minus,
};
